import IspReportsAPI from '../../api/ispReports';
import MonitoringAPI from '../../api/monitoring';

const state = {
  motivos: { data: null, isFetching: false, error: null },
  fcr: { data: null, isFetching: false, error: null },
  recorrencia: { data: null, isFetching: false, error: null },
  painel: { data: null, isFetching: false, error: null },
  monitoring: { data: null, isFetching: false, error: null },
  monitoringParams: {}, // GK-HUB: last fetch params (teamId) for WebSocket re-fetch
  agentRanking: { data: null, isFetching: false, error: null }, // GK-HUB: Agent ranking report
  agentDetail: { data: null, isFetching: false, error: null }, // GK-HUB: Agent detail slide-over
  queueMetrics: { data: null, isFetching: false, error: null }, // GK-HUB: Queue metrics historical
  csat: { data: null, isFetching: false, error: null }, // GK-HUB: CSAT ISP report
  csatResponses: { data: null, isFetching: false, error: null }, // GK-HUB: CSAT drill-down
  conversas: { data: null, isFetching: false, error: null }, // GK-HUB: Conversations report
  conversasDetail: { data: null, isFetching: false, error: null }, // GK-HUB: Conversation detail
  recorrenciaDetail: { data: null, isFetching: false, error: null }, // GK-HUB: Recorrencia contact detail
  campanhas: { data: null, isFetching: false, error: null }, // GK-HUB: Campaign analytics report
  motivosList: [],
};

const getters = {
  getMotivos: $state => $state.motivos,
  getFcr: $state => $state.fcr,
  getRecorrencia: $state => $state.recorrencia,
  getPainel: $state => $state.painel,
  getMonitoring: $state => $state.monitoring,
  getAgentRanking: $state => $state.agentRanking, // GK-HUB: Agent ranking
  getAgentDetail: $state => $state.agentDetail, // GK-HUB: Agent detail slide-over
  getQueueMetrics: $state => $state.queueMetrics, // GK-HUB: Queue metrics
  getCsat: $state => $state.csat, // GK-HUB: CSAT ISP report
  getCsatResponses: $state => $state.csatResponses, // GK-HUB: CSAT drill-down
  getConversas: $state => $state.conversas, // GK-HUB: Conversations report
  getConversasDetail: $state => $state.conversasDetail, // GK-HUB: Conversation detail
  getRecorrenciaDetail: $state => $state.recorrenciaDetail, // GK-HUB: Recorrencia detail
  getCampanhas: $state => $state.campanhas, // GK-HUB: Campaign analytics report
  getMotivosList: $state => $state.motivosList,
};

const actions = {
  async fetchMotivos({ commit }, params) {
    commit('setFetching', { key: 'motivos', value: true });
    commit('setError', { key: 'motivos', error: null });
    try {
      const { data } = await IspReportsAPI.getMotivos(params);
      commit('setData', { key: 'motivos', data });
    } catch (error) {
      commit('setError', {
        key: 'motivos',
        error: error.message || 'Failed to load data',
      });
    } finally {
      commit('setFetching', { key: 'motivos', value: false });
    }
  },

  async fetchFcr({ commit }, params) {
    commit('setFetching', { key: 'fcr', value: true });
    commit('setError', { key: 'fcr', error: null });
    try {
      const { data } = await IspReportsAPI.getFcr(params);
      commit('setData', { key: 'fcr', data });
    } catch (error) {
      commit('setError', {
        key: 'fcr',
        error: error.message || 'Failed to load data',
      });
    } finally {
      commit('setFetching', { key: 'fcr', value: false });
    }
  },

  async fetchRecorrencia({ commit }, params) {
    commit('setFetching', { key: 'recorrencia', value: true });
    commit('setError', { key: 'recorrencia', error: null });
    try {
      const { data } = await IspReportsAPI.getRecorrencia(params);
      commit('setData', { key: 'recorrencia', data });
    } catch (error) {
      commit('setError', {
        key: 'recorrencia',
        error: error.message || 'Failed to load data',
      });
    } finally {
      commit('setFetching', { key: 'recorrencia', value: false });
    }
  },

  async fetchPainel({ commit }, params) {
    commit('setFetching', { key: 'painel', value: true });
    commit('setError', { key: 'painel', error: null });
    try {
      const { data } = await IspReportsAPI.getPainel(params);
      commit('setData', { key: 'painel', data });
    } catch (error) {
      commit('setError', {
        key: 'painel',
        error: error.message || 'Failed to load data',
      });
    } finally {
      commit('setFetching', { key: 'painel', value: false });
    }
  },

  // GK-HUB: Agent ranking report
  async fetchAgentRanking({ commit }, params) {
    commit('setFetching', { key: 'agentRanking', value: true });
    commit('setError', { key: 'agentRanking', error: null });
    try {
      const { data } = await IspReportsAPI.getAgentRanking(params);
      commit('setData', { key: 'agentRanking', data });
    } catch (error) {
      commit('setError', {
        key: 'agentRanking',
        error: error.message || 'Failed to load data',
      });
    } finally {
      commit('setFetching', { key: 'agentRanking', value: false });
    }
  },
  // GK-HUB: end agent ranking

  // GK-HUB: Agent detail slide-over (consolidated per-agent data)
  async fetchAgentDetail({ commit }, params) {
    commit('setFetching', { key: 'agentDetail', value: true });
    commit('setError', { key: 'agentDetail', error: null });
    try {
      const { data } = await IspReportsAPI.getAgentDetail(params);
      commit('setData', { key: 'agentDetail', data });
    } catch (error) {
      commit('setError', {
        key: 'agentDetail',
        error: error.message || 'Failed to load data',
      });
    } finally {
      commit('setFetching', { key: 'agentDetail', value: false });
    }
  },

  clearAgentDetail({ commit }) {
    commit('setData', { key: 'agentDetail', data: null });
  },
  // GK-HUB: end agent detail

  // GK-HUB: Queue metrics historical report
  async fetchQueueMetrics({ commit }, params) {
    commit('setFetching', { key: 'queueMetrics', value: true });
    commit('setError', { key: 'queueMetrics', error: null });
    try {
      const { data } = await IspReportsAPI.getQueueMetrics(params);
      commit('setData', { key: 'queueMetrics', data });
    } catch (error) {
      commit('setError', {
        key: 'queueMetrics',
        error: error.message || 'Failed to load data',
      });
    } finally {
      commit('setFetching', { key: 'queueMetrics', value: false });
    }
  },
  // GK-HUB: end queue metrics

  // GK-HUB: CSAT ISP report
  async fetchCsat({ commit }, params) {
    commit('setFetching', { key: 'csat', value: true });
    commit('setError', { key: 'csat', error: null });
    try {
      const { data } = await IspReportsAPI.getCsat(params);
      commit('setData', { key: 'csat', data });
    } catch (error) {
      commit('setError', {
        key: 'csat',
        error: error.message || 'Failed to load data',
      });
    } finally {
      commit('setFetching', { key: 'csat', value: false });
    }
  },

  // GK-HUB: CSAT drill-down — paginated responses for an agent/inbox
  async fetchCsatResponses({ commit }, params) {
    commit('setFetching', { key: 'csatResponses', value: true });
    commit('setError', { key: 'csatResponses', error: null });
    try {
      const { data } = await IspReportsAPI.getCsatResponses(params);
      commit('setData', { key: 'csatResponses', data });
    } catch (error) {
      commit('setError', {
        key: 'csatResponses',
        error: error.message || 'Failed to load data',
      });
    } finally {
      commit('setFetching', { key: 'csatResponses', value: false });
    }
  },

  // GK-HUB: clear CSAT drill-down data (on drawer close)
  clearCsatResponses({ commit }) {
    commit('setData', { key: 'csatResponses', data: null });
  },
  // GK-HUB: end csat

  // GK-HUB: Conversations report (paginated list + summary)
  async fetchConversas({ commit }, params) {
    commit('setFetching', { key: 'conversas', value: true });
    commit('setError', { key: 'conversas', error: null });
    try {
      const { data } = await IspReportsAPI.getConversas(params);
      commit('setData', { key: 'conversas', data });
    } catch (error) {
      commit('setError', {
        key: 'conversas',
        error: error.message || 'Failed to load data',
      });
    } finally {
      commit('setFetching', { key: 'conversas', value: false });
    }
  },

  // GK-HUB: Conversation detail with messages timeline
  async fetchConversasDetail({ commit }, conversationId) {
    commit('setFetching', { key: 'conversasDetail', value: true });
    commit('setError', { key: 'conversasDetail', error: null });
    try {
      const { data } = await IspReportsAPI.getConversasDetail(conversationId);
      commit('setData', { key: 'conversasDetail', data });
    } catch (error) {
      commit('setError', {
        key: 'conversasDetail',
        error: error.message || 'Failed to load data',
      });
    } finally {
      commit('setFetching', { key: 'conversasDetail', value: false });
    }
  },
  // GK-HUB: end conversas

  // GK-HUB: Recorrencia detail (contact info + conversations, teamId replaces departmentId)
  async fetchRecorrenciaDetail(
    { commit },
    { contactId, from, to, teamId } = {}
  ) {
    commit('setFetching', { key: 'recorrenciaDetail', value: true });
    commit('setError', { key: 'recorrenciaDetail', error: null });
    try {
      const { data } = await IspReportsAPI.getRecorrenciaDetail(contactId, {
        from,
        to,
        teamId,
      });
      commit('setData', { key: 'recorrenciaDetail', data });
    } catch (error) {
      commit('setError', {
        key: 'recorrenciaDetail',
        error: error.message || 'Failed to load data',
      });
    } finally {
      commit('setFetching', { key: 'recorrenciaDetail', value: false });
    }
  },
  // GK-HUB: end recorrencia detail

  // GK-HUB: Campaign analytics report
  async fetchCampanhas({ commit }, params) {
    commit('setFetching', { key: 'campanhas', value: true });
    commit('setError', { key: 'campanhas', error: null });
    try {
      const { data } = await IspReportsAPI.getCampanhas(params);
      commit('setData', { key: 'campanhas', data });
    } catch (error) {
      commit('setError', {
        key: 'campanhas',
        error: error.message || 'Failed to load data',
      });
    } finally {
      commit('setFetching', { key: 'campanhas', value: false });
    }
  },
  // GK-HUB: end campanhas

  async fetchMotivosList({ commit }) {
    try {
      const { data } = await IspReportsAPI.getMotivosList();
      commit('setMotivosList', data.motivos || []);
    } catch {
      // silently fail — motivos list is non-critical
    }
  },

  async fetchMonitoring({ commit }, params) {
    commit('setMonitoringParams', params || {}); // GK-HUB: save params for WebSocket re-fetch
    commit('setFetching', { key: 'monitoring', value: true });
    commit('setError', { key: 'monitoring', error: null });
    try {
      const { data } = await MonitoringAPI.get(params);
      commit('setData', { key: 'monitoring', data });
    } catch (error) {
      commit('setError', {
        key: 'monitoring',
        error: error.message || 'Failed to load data',
      });
    } finally {
      commit('setFetching', { key: 'monitoring', value: false });
    }
  },

  // GK-HUB (#109): viewer heartbeat/leave — best-effort (nunca quebra o painel se falhar).
  // Registra/remove o viewer no MonitoringViewerTracker; alimenta o gate de enqueue (#106).
  // Fire-and-forget: heartbeat é oportunista (a próxima batida recupera) e o leave tem o
  // VIEWER_TTL como rede de segurança se falhar.
  sendMonitoringHeartbeat() {
    return MonitoringAPI.viewerHeartbeat().catch(() => {});
  },

  sendMonitoringLeave() {
    return MonitoringAPI.viewerLeave().catch(() => {});
  },

  // GK-HUB: O broadcast WebSocket ja carrega o payload completo da conta (account-wide,
  // sem filtro de time) e e debounced no backend (3s/conta). Para quem enxerga a conta
  // inteira — admin/manager SEM filtro de time — esse payload e exatamente o que o GET
  // retornaria, entao consumimos direto e evitamos reexecutar o MonitoringBuilder (caro:
  // ate dezenas de segundos em producao) por cliente a cada broadcast, o que saturava a
  // CPU do Rails. Supervisores (escopados por time no backend) e qualquer filtro de time
  // ativo continuam refazendo o GET para receber dados corretos/escopados. (#59)
  onMonitoringUpdate({ dispatch, commit, state: $state, rootGetters }, data) {
    const role = rootGetters.getCurrentRole;
    const hasTeamFilter = Boolean(
      $state.monitoringParams && $state.monitoringParams.teamId
    );
    // GK-HUB: só admin é garantidamente account-wide. Manager pode ser escopado por time
    // (#62 — alinhado ao backend team_scope_params/PermissionFilterService), então só admin
    // consome o payload account-wide do WS; os demais refazem o GET escopado. (#59/#62)
    const seesAccountWide = role === 'administrator' && !hasTeamFilter;

    if (seesAccountWide && data) {
      commit('setData', { key: 'monitoring', data });
      return;
    }

    dispatch('fetchMonitoring', $state.monitoringParams);
  },
  // GK-HUB: end team-scoped monitoring update
};

const mutations = {
  setFetching($state, { key, value }) {
    $state[key].isFetching = value;
  },
  setData($state, { key, data }) {
    $state[key].data = data;
    $state[key].error = null;
  },
  setError($state, { key, error }) {
    $state[key].error = error;
  },
  setMotivosList($state, motivos) {
    $state.motivosList = motivos;
  },
  setMonitoringParams($state, params) {
    // GK-HUB: persist last fetch params for WebSocket re-fetch
    $state.monitoringParams = params || {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
